// extracted by mini-css-extract-plugin
export default {"root":"NB8BQ","avatar":"CHYa5"};